import { type Node } from '@xyflow/react'

export const NODE_TYPE_NAMES = {
  Ghost: 'Ghost Node',
  GroupNode: 'Group Node',
  NodeAgency: 'Agency Node',
  NodeAgent: 'Agent Node',
  NodeAIKnot: 'AI Knot Node',
  NodeAnnotation: 'Annotation Node',
  NodeComposite: 'Composite Document Node',
  NodeDiagrams: 'Diagram Node (Plant UML)',
  NodeDiagramsMermaid: 'Diagram Node (Mermaid)',
  NodeDocument: 'Document Node',
  NodeDocumentDesigner: 'Document Designer',
  NodeDomainKnowledge: 'Domain Knowledge Node',
  NodeFileMiner: 'File Miner Node',
  NodeFileResource: 'File Resource Node',
  NodeFileResourcePDF: 'PDF Resource Node',
  NodeGlobalConstants: 'Global Constants Node',
  NodeGroupBlueprint: 'Blueprint Reference Node',
  NodeHTMLFields: 'HTML Fields Node',
  NodeImageGenerator: 'Image Generator Node',
  NodeIntellica: 'Intellica',
  NodeJavascript: 'JavaScript Node',
  NodeKnowledgeSet: 'Knowledge Set Node',
  NodePresence: 'Presence Node',
  NodeQuickStart: 'Quick Start Node',
  NodeQuickStartDynamic: 'Quick Start Dynamic Node',
  NodeSmartNotes: 'Smart Notes Node', NodeStrategy: 'Strategy Node',
  NodeWebExtract: 'Web Extract Node',
  NodeWebSearch: 'Web Search Node',
  NodeWorkflow: 'Workflow Node',
}

export const nodeColor = (node: Node) => {
  switch (node.type) {
    case 'ghost':
      return '#101000' // Default black for ghost
    case 'groupnode':
      return '#64748b' // Slate-500 for group nodes
    case 'nodeagency':
      return '#8b5cf6' // Violet-500 color for agency nodes
    case 'nodeagent':
      return '#9333ea' // Purple-600 for agent nodes
    case 'nodeaiknot':
      return '#f59e0b' // Amber-500 color for AI Knot nodes
    case 'nodeannotation':
      return '#101000' // Default black for annotation
    case 'nodecomposite':
      return '#ec4899' // Pink-500 color for composite nodes
    case 'nodediagrams':
      return '#2040a0' // Blue color for diagram nodes
    case 'nodediagramsmermaid':
      return '#2040a0' // Blue color for mermaid diagram nodes
    case 'nodedocument':
      return '#008040' // Light green color for document nodes
    case 'nodedocumentDesigner':
      return '#800080' // Purple color for document designer nodes
    case 'nodedomainknowledge':
      return '#7c3aed' // Violet-600 color for domain knowledge nodes
    case 'nodefileminer':
      return '#d97706' // Amber-600 color for file miner nodes
    case 'nodefileresource':
      return '#4682B4' // Steel Blue color for resource nodes
    case 'nodefileresourcepdf':
      return '#dc2626' // Red-600 for PDF resource
    case 'nodeglobalconstants':
      return '#64748b' // Slate-500 for global constants
    case 'nodeGroupblueprint':
      return '#3b82f6' // Blue-500 for blueprint reference
    case 'nodeHTMLfields':
      return '#f59e0b' // Amber-500 for HTML fields
    case 'nodeImagegenerator':
      return '#db2777' // Pink-600 color for image generator nodes
    case 'nodeintellica':
      return '#8b5cf6' // Violet-500 color for intellica nodes
    case 'nodejavascript':
      return '#f59e0b' // Amber-500 for javascript nodes
    case 'nodeknowledgeset':
      return '#8b5cf6' // Violet-500 for knowledge set
    case 'nodepresence':
      return '#3b82f6' // Blue-500 color for presence nodes
    case 'nodequickstart':
      return '#0080c0' // Light blue color for quickstart
    case 'nodequickstartdynamic':
      return '#0080c0' // Light blue color for quickstart
    case 'nodesmartnotes':
      return '#ff8040' // Orange color for smart notes nodes
    case 'nodestrategy':
      return '#0d9488' // Teal-600 color for strategy nodes    case 'nodewebextract':
      return '#0ea5e9' // Sky-500 for web extract
    case 'nodewebsearch':
      return '#06b6d4' // Cyan-500 for web search
    case 'nodeworkflow':
      return '#059669' // Emerald-600 for workflow
    default:
      return '#101000' // Default fallback color is black
  }
}

export const NodeAgency = 'NodeAgency'
export const NodeAgent = 'NodeAgent'
export const NodeAIKnot = 'NodeAIKnot'
export const NodeAnnotation = 'NodeAnnotation'
export const NodeComposite = 'NodeComposite'
export const NodeDiagrams = 'NodeDiagrams'
export const NodeDiagramsMermaid = 'NodeDiagramsMermaid'
export const NodeDocument = 'NodeDocument'
export const NodeDocumentDesigner = 'NodeDocumentDesigner'
export const NodeDomainKnowledge = 'NodeDomainKnowledge'
export const NodeFileMiner = 'NodeFileMiner'
export const NodeFileResource = 'NodeFileResource'
export const NodeFileResourcePDF = 'NodeFileResourcePDF'
export const NodeGlobalConstants = 'NodeGlobalConstants'
export const NodeGroup = 'GroupNode'
export const NodeGroupBlueprint = 'NodeGroupBlueprint'
export const NodeHTMLFields = 'NodeHTMLFields'
export const NodeImageGenerator = 'NodeImageGenerator'
export const NodeIntellica = 'NodeIntellica'
export const NodeJavascript = 'NodeJavascript'
export const NodeKnowledgeSet = 'NodeKnowledgeSet'
export const NodePresence = 'NodePresence'
export const NodeQuickStart = 'NodeQuickStart'
export const NodeQuickStartDynamic = 'NodeQuickStartDynamic'
export const NodeSmartNotes = 'NodeSmartNotes'
export const NodeStrategy = 'NodeStrategy'
export const NodeWebExtract = 'NodeWebExtract'
export const NodeWebSearch = 'NodeWebSearch'
export const NodeWorkflow = 'NodeWorkflow'
export const Ghost = 'Ghost'